import { Injectable, inject } from '@angular/core';
import { UserService } from './user.service';
import { PlatformGraphQlService } from '../graphql/platform-graphql.service';
import { catchError, Observable, of, tap } from 'rxjs';
import { ApolloError } from '@apollo/client/errors';

@Injectable({
  providedIn: 'root',
})
export class UserGroupsService {
  private _user = inject(UserService);
  private _platformApi = inject(PlatformGraphQlService);

  /**
   * Add user to provided group
   * @param group
   */
  public addToGroup(segmentId: string): Observable<any> {
    return this._platformApi.addUsersSegment(segmentId).pipe(
      catchError((error: ApolloError) => {
        return of(false);
      }),
      tap(e => {
        if (e && !this.isExistGroup(segmentId)) {
          this._user.info.segments.push(segmentId);
        }
      }),
    );
  }

  /**
   * Remove user from provided group
   * @param group
   */
  public removeFromGroup(segmentId: string): Observable<any> {
    return this._platformApi.deleteUsersSegment(segmentId).pipe(
      catchError((error: ApolloError) => {
        return of(false);
      }),
      tap(e => {
        if (e && this.isExistGroup(segmentId)) {
          this._user.info.segments = this._user.info.segments.filter(s => s !== segmentId);
        }
      }),
    );
  }

  /**
   * Is exist group in user`s groups
   * @param group
   */
  public isExistGroup(groupId: number | string): boolean {
    if (!this._user.auth || !this._user?.info?.segments?.length) {
      return null;
    }
    return Boolean(this._user.info.segments.find(segment => segment === groupId));
  }

  /**
   * Check already added user group
   * @param segment
   * @param segments
   */
  public alreadyExistUserGroup(segment: any, segments: any[]): boolean {
    return segments?.some(item => item.includes(segment));
  }

  /**
   * The function checks if all elements in a subArray exist in a user's groups.
   * @param {any[]} subArray - The `subArray` parameter is an array of elements that you want to check
   * for existence within the `segments` array of the `_user.info` object. The function
   * `isExistGroupsInUserGroups` checks if all elements in `subArray` are included in the `segments`
   * array of
   * @returns A boolean value is being returned.
   */
  public isExistGroupsInUserGroups(subArray: any[]): boolean {
    return subArray?.every(element => (this._user?.info?.segments || [])?.includes(element));
  }
}
